import {createFeature, createReducer, createSelector, on} from '@ngrx/store';
import {CommonsActions} from "./commons.actions";

export interface AppState {
  commons: CommonsState;
}

export interface CommonsState {
  loading: boolean;
  count: number;
}

const initialState: CommonsState = {
  loading: false,
  count: 0
}

export const commons = createReducer(
  initialState,

  on(CommonsActions.setLoaderOn, (state) => ({
    ...state,
    loading: true,
    count: state.count + 1,
  })),

  on(CommonsActions.setLoaderOff, (state) => ({
    ...state,
    loading: (state.count - 1 > 0),
    count: (state.count - 1)
  }))
);

export const selectFeature = (state: AppState) => state.commons;

export const loadingSelector = createSelector(
  selectFeature,
  (state: CommonsState) => {
    return state.loading;
  }
);
